/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ConnectionRequestAction { 
    connection_status: ConnectionRequestAction.ConnectionStatusEnum;
}
export namespace ConnectionRequestAction {
    export type ConnectionStatusEnum = 'Verified' | 'Rejected';
    export const ConnectionStatusEnum = {
        Verified: 'Verified' as ConnectionStatusEnum,
        Rejected: 'Rejected' as ConnectionStatusEnum
    };
}